import styled, { css } from "styled-components";
import * as StyledTypography from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

export const SocialShareWrapper = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.xl,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
      0
    `};
  summary {
    list-style: none;
  }
  ul {
    padding: 0;
    li {
      list-style: none;
    }
  }
  ${(props) =>
    props.sticky &&
    css`
      /* lg to xl */
      @media ${({ theme }) => theme.breakpoints.xl} {
        position: sticky;
        top: 88px;
      }
    `}

  /* Sticky behavior from 1200px onwards */
  @media (min-width: 1200px) {
    position: sticky;
    top: ${({ $topOffset }) => $topOffset || 88}px;
    align-self: flex-start;
  }

  /* Hide animation when shouldHide is true */
  ${({ $shouldHide }) =>
    $shouldHide &&
    css`
      opacity: 0;
      visibility: hidden;
    `}
`;

export const SocialShareLink = styled(StyledTypography.StyledLink)``;

export const SocialShareSummary = styled(StyledTypography.TypoCaption1)``;

export const SocialShareList = styled(StyledTypography.TypoOverline2)`
  text-transform: uppercase;
  padding-bottom: ${({ theme }) => theme.fontScale.majorSecond.size}rem;
  &:last-child {
    padding-bottom: 0;
  }
`;
